/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Site serializer.
 * @export
 * @interface SiteAnalytics
 */
export interface SiteAnalytics {
    /**
     * 
     * @type {string}
     * @memberof SiteAnalytics
     */
    readonly id: string;
    /**
     * 
     * @type {number}
     * @memberof SiteAnalytics
     */
    readonly ownerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof SiteAnalytics
     */
    siteName?: string;
    /**
     * Gets emission count if specified.
     * @type {number}
     * @memberof SiteAnalytics
     */
    readonly emissionCount: number;
    /**
     * Gets emission count if specified.
     * @type {number}
     * @memberof SiteAnalytics
     */
    readonly emissionsBelowThresholdCount: number;
    /**
     * Gets nondetects_count count if specified.
     * @type {number}
     * @memberof SiteAnalytics
     */
    readonly nondetectsCount: number;
    /**
     * Gets emission_ratio if specified.
     * @type {number}
     * @memberof SiteAnalytics
     */
    readonly emissionRatio: number;
}

/**
 * Check if a given object implements the SiteAnalytics interface.
 */
export function instanceOfSiteAnalytics(value: object): value is SiteAnalytics {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('ownerId' in (value as Record<string, any>)) && !('owner_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['ownerId'] === undefined && (value as Record<string, any>)['owner_id'] === undefined)) return false;
    if ((!('emissionCount' in (value as Record<string, any>)) && !('emission_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionCount'] === undefined && (value as Record<string, any>)['emission_count'] === undefined)) return false;
    if ((!('emissionsBelowThresholdCount' in (value as Record<string, any>)) && !('emissions_below_threshold_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionsBelowThresholdCount'] === undefined && (value as Record<string, any>)['emissions_below_threshold_count'] === undefined)) return false;
    if ((!('nondetectsCount' in (value as Record<string, any>)) && !('nondetects_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['nondetectsCount'] === undefined && (value as Record<string, any>)['nondetects_count'] === undefined)) return false;
    if ((!('emissionRatio' in (value as Record<string, any>)) && !('emission_ratio' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionRatio'] === undefined && (value as Record<string, any>)['emission_ratio'] === undefined)) return false;
    return true;
}

export function SiteAnalyticsFromJSON(json: any): SiteAnalytics {
    return SiteAnalyticsFromJSONTyped(json, false);
}

export function SiteAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteAnalytics {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'ownerId': json['owner_id'],
        'siteName': json['site_name'] == null ? undefined : json['site_name'],
        'emissionCount': json['emission_count'],
        'emissionsBelowThresholdCount': json['emissions_below_threshold_count'],
        'nondetectsCount': json['nondetects_count'],
        'emissionRatio': json['emission_ratio'],
    };
}

export function SiteAnalyticsToJSON(json: any): SiteAnalytics {
    return SiteAnalyticsToJSONTyped(json, false);
}

export function SiteAnalyticsToJSONTyped(value?: Omit<SiteAnalytics, 'id'|'ownerId'|'emissionCount'|'emissionsBelowThresholdCount'|'nondetectsCount'|'emissionRatio'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'site_name': value['siteName'],
    };
}

